import { render, staticRenderFns } from "./MySuperTalk.vue?vue&type=template&id=3a9831f6&scoped=true"
import script from "./MySuperTalk.vue?vue&type=script&lang=js"
export * from "./MySuperTalk.vue?vue&type=script&lang=js"
import style0 from "./MySuperTalk.vue?vue&type=style&index=0&id=3a9831f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9831f6",
  null
  
)

export default component.exports